// front/src/api/ordersApi.js
import http from '../http';

export async function fetchOrders(params = {}) {
  const res = await http.get('/api/admin/orders', { params });
  return res.data;
}

export async function fetchOrder(id) {
  const res = await http.get(`/api/admin/orders/${id}`);
  return res.data;
}

export async function createOrder(payload) {
  const res = await http.post('/api/admin/orders', payload);
  return res.data;
}

export async function updateOrder(id, payload) {
  const res = await http.patch(`/api/admin/orders/${id}`, payload);
  return res.data;
}
